var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{attrs:{"data-cy":"loading","id":"loading"}},[_c('div',{staticClass:"loader"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }